import { Component, Input, Output, EventEmitter } from '@angular/core';

export interface TabItem {
  value: string;
  label: string;
  iconPath?: string;
  matIcon?: string;
  badge?: number;
  perms?: string[];
}

@Component({
  selector: 'app-tabs-ui',
  templateUrl: './tabs-ui.component.html',
  styleUrls: ['./tabs-ui.component.css'],
})
export class TabsUiComponent {
  @Input() tabs: TabItem[] = [];
  @Input() activeTab: string = '';
  @Input() variant: 'pill' | 'pill-outline' | 'underline' = 'underline';
  @Output() tabChange = new EventEmitter<string>();
}
